export default __webpack_public_path__ + "static/media/rugbyLoadingSpinner.9fd502e7.gif";